<div class="tax-strategy new-input-fields">
  <div class="row">
    <div class="medium-1 columns"></div>
    <div class="medium-10 columns" style="margin-bottom: 25px;">
      <div class="create-strategy-sec-bar">
        <div class="pointer create-strategy-sec" [ngClass]="{'is-active': currentSection == 'overview'}" (click)="currentSection = 'overview'">
          <div class="sec-name">Overview</div>
        </div>
        <div class="pointer create-strategy-sec" [ngClass]="{'is-active': currentSection == 'internal'}" (click)="currentSection = 'internal'">
          <div class="sec-name">Internal</div>
        </div>
        <div class="pointer create-strategy-sec" [ngClass]="{'is-active': currentSection == 'resources'}" (click)="currentSection = 'resources'">
          <div class="sec-name">Resources</div>
        </div>
        <div class="pointer create-strategy-sec" [ngClass]="{'is-active': currentSection == 'tasks'}" (click)="currentSection = 'tasks'">
          <div class="sec-name">Tasks</div>
        </div>
        <div class="pointer create-strategy-sec" [ngClass]="{'is-active': currentSection == 'review'}" (click)="currentSection = 'review'">
          <div class="sec-name">Review</div>
        </div>
      </div>
    </div>
    <div class="medium-1 columns"></div>
  </div>
  <div class="row" style="height: calc(90vh - 23vh);overflow: auto">
    <div class="medium-12 columns" style="margin-top: 20px;" *ngIf="currentSection == 'overview'">
      <div class="row">
        <div class="medium-12 columns">
          <label style="font-weight: 600;color: #333333;">{{editMode ? 'Update Tax Strategy' : 'Create New Tax Strategy'}}</label>
          <label style="font-size: 12px;font-weight: 400;color: #475467;">Provide Tax Strategy's Information</label>
          <hr/>
        </div>
      </div>
      <div class="row">
        <div class="medium-6 columns">
          <label>
            Name*
            <input type="text" placeholder="Name" [(ngModel)]="taxStrategy.name">
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Category*
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="stratagiesTypes" [setPlaceHolder]="'Select Type'"
                                   [setSearchKey]="'type'" [setValueKey]="'id'" [setDefaultValue]="taxStrategy.typeId"
                                   (onValueSelect)="onStrategyTypeSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Federal Associated Rate
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="associatedWith" [setPlaceHolder]="'Federal Associated Rate'"
                                   [setSearchKey]="'name'" [setValueKey]="'id'" [setDefaultValue]="taxStrategy.associatedWith"
                                   (onValueSelect)="onStrategyAssociatedWithSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            State Associated Rate
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="stateAssociatedWith" [setPlaceHolder]="'State Associated Rate'"
                                   [setSearchKey]="'name'" [setValueKey]="'id'" [setDefaultValue]="taxStrategy.stateAssociatedWith"
                                   (onValueSelect)="onStrategyStateAssociatedWithSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-12 columns margin-top-20" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="address-bar row-margin">
            <span class="pointer popup-label" style="color: #1570EF" (click)="addCustomTaxRate()"><i class="icon ion-ios-plus-outline"></i>Custom Rate</span>
          </div>
          <div class="address-bar row row-margin" *ngIf="(taxStrategy.customTaxRates && taxStrategy.customTaxRates.length > 0) || (tempCustomRates.length > 0)">
            <div class="small-12 columns">
              <div style="clear: both;" *ngFor="let customRate of taxStrategy.customTaxRates;let index = index;">
                <ng-template [ngIf]="!customRate.isEditing">
                  <div class="row">
                    <div class="custom-rate-box">
                      <div style="float:left;margin-right: 10px;">{{customRate.name}}</div>
                      <div style="margin-right: 10px;float:left; color: #14B5F0;">{{customRate.rate}}%</div>
                      <span *ngIf="customRate.formula && customRate.formula.displayValue === customRate.formula.actualValue" class="pointer checklist-remove float-left" style="color: #878787;" (click)="editCustomRate(customRate)">
                       <i class="icon ion-edit ion-close-round workflow-font"></i>
                      </span>
                      <span *ngIf="customRate.formula && customRate.formula.displayValue !== customRate.formula.actualValue" class="pointer checklist-remove float-left" style="color: #878787;" (click)="showEditForCustomRate(customRate)">
                       <i class="icon ion-edit ion-close-round workflow-font"></i>
                      </span>
                      <span class="pointer checklist-remove float-left" style="color: #878787;" (click)="removeCustomRate(customRate, index)">
                      <i class="icon ion-close-round workflow-font"></i>
                      </span>
                    </div>
                  </div>
                </ng-template>
                <ng-template [ngIf]="customRate.isEditing">
                  <input type="text" class="float-left" style="width: 50%" [(ngModel)]="customRate.tempName" placeholder="Enter Name"/>
                  <input type="text" class="float-left" style="width: 25%; margin-left: 10px;" [(ngModel)]="customRate.tempRate" placeholder="23"/>
                  <span class="float-left">
                    <span style="position: relative;top: 8px;">(OR)</span>
                    <span class="badge-tooltip"><span style="position: relative;top: 8px;padding-left: 15px;"><i style="font-size: 1.5em" class="icon ion-ios-calculator-outline" (click)="showEditForCustomRate(customRate)"></i><span class='bottomTooltiptext tpActionTooltip' style="font-size: 13px !important;width: 150px !important;">Build your formula</span></span></span>
                  </span>
                  <span style="position: relative;top: 8px;">
                    <i class="ion-ios-checkmark-outline save-row-icon float-left" style="margin-left: 10px;" (click)="updateCustomRate(customRate)"></i>
                    <i class="icon ion-ios-close-outline manage-strategy-icon float-left" style="margin-left: 10px;" (click)="stopEditing(customRate)"></i>
                  </span>
                </ng-template>
              </div>
              <div class="custom-rate" style="clear: both;" *ngFor="let customRate of tempCustomRates;let index = index;">
                <input type="text" class="float-left" style="width: 50%" [(ngModel)]="customRate.name" placeholder="Enter Name"/>
                <input type="text" class="float-left" style="width: 25%; margin-left: 10px;" [(ngModel)]="customRate.rate" placeholder="23"/>
                <span class="float-left">
                  <span style="position: relative;top: 8px;">(OR)</span>
                  <span class="badge-tooltip"><span style="position: relative;top: 8px;padding-left: 15px;"><i style="font-size: 1.5em" class="icon ion-ios-calculator-outline" (click)="openFormulaCalculator(customRate, index)"></i><span class='bottomTooltiptext tpActionTooltip' style="font-size: 13px !important;width: 150px !important;">Build your formula</span></span></span>
                </span>
                <span style="position: relative;top: 8px;">
                  <i class="ion-ios-checkmark-outline save-row-icon float-left" style="margin-left: 10px;" (click)="appendCustomRate(customRate, index)"></i>
                  <i class="icon ion-ios-close-outline manage-strategy-icon float-left" style="margin-left: 10px;" (click)="stopAdding(index)"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Recurring
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="recurringTypes" [setPlaceHolder]="'Select Recurring'"
                                   [setSearchKey]="'key'" [setValueKey]="'value'" [setDefaultValue]="taxStrategy.recurring"
                                   (onValueSelect)="onStrategyRecurringSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Applicable To*
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="applicableTo" [setPlaceHolder]="'Applicable To'"
                                   [setSearchKey]="'key'" [setValueKey]="'value'" [setDefaultValue]="taxStrategy.applicableTo"
                                   (onValueSelect)="setApplicableTo($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Complexity
            <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
              <i class="icon ion-ios-information-outline info-icon" style="font-size: 16px; color: #475467;"></i>
              <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 200px !important; line-height: 1.35;">
                <strong>Complexity (projected tax-savings calculation)</strong><br />
              1 Single Input: One primary field determines the result<br />
              2 Multiple Inputs: Several fields combine into one result<br />
              3 Conditional: Rules, limits, or comparisons change the result<br />
              4 Complex: Multiple linked calculations, years, or outcomes<br />
              5 Specialized: Requires a strategy-specific calculation<br />
              </span>
            </span>
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="complexity" [setPlaceHolder]="'Complexity'"
                                   [setSearchKey]="'key'" [setValueKey]="'value'" [setDefaultValue]="taxStrategy.complexity"
                                   (onValueSelect)="setComplexity($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Urgency
            <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
              <i class="icon ion-ios-information-outline info-icon" style="font-size: 16px; color: #475467;"></i>
              <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 200px !important; line-height: 1.35;">
                <strong>Urgency (the strategy's deadline)</strong><br />
                1 No deadline<br />
                2 Annual (by 12/31)<br />
                3 Quarterly (estimates/elections)<br />
                4 Weeks (deal closing / election window)<br />
                5 Days (emergency window)<br />
              </span>
            </span>
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="urgencyLevels" [setPlaceHolder]="'Urgency'"
                                   [setSearchKey]="'key'" [setValueKey]="'value'" [setDefaultValue]="taxStrategy.urgency"
                                   (onValueSelect)="setUrgency($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Risk Level
            <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
              <i class="icon ion-ios-information-outline info-icon" style="font-size: 16px; color: #475467;"></i>
              <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 320px !important; line-height: 1.35;">
                <strong>Risk (relative uncertainty and scrutiny)</strong><br />
                1 Minimal: Clearly established in tax law<br />
                2 Low: Well established and widely accepted<br />
                3 Moderate: Established planning with some judgment involved<br />
                4 Heightened: Less guidance or case law; may face greater scrutiny<br />
                5 Significant: May require additional IRS disclosure<br />
              </span>
            </span>
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="riskLevels" [setPlaceHolder]="'Select Risk Level'"
                                   [setSearchKey]="'key'" [setValueKey]="'value'" [setDefaultValue]="taxStrategy.riskLevel"
                                   (onValueSelect)="setRiskLevel($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Burden
            <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
              <i class="icon ion-ios-information-outline info-icon" style="font-size: 16px; color: #475467;"></i>
              <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 200px !important; line-height: 1.35;">
                <strong>Burden (on the advisor's firm)</strong><br />
                1 Mostly the client<br />
                2 Client with advisor help<br />
                3 Half client/advisor<br />
                4 Mostly tax advisor<br />
                5 Concierge<br />
              </span>
            </span>
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="burdenLevels" [setPlaceHolder]="'Burden'"
                                   [setSearchKey]="'key'" [setValueKey]="'value'" [setDefaultValue]="taxStrategy.burden"
                                   (onValueSelect)="setBurden($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Deadline
            <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'MM/DD'" [mindate]="'past'" [(ngModel)]="taxStrategy.deadline"
                   (valueChanged)="setStrategyDeadline($event)"  placeholder="Deadline(MM/DD)"/>
          </label>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Last Updated
            <input type="text" placeholder="Last Updated" [(ngModel)]="taxStrategy.lastUpdated">
          </label>
        </div>
        <div class="medium-12 columns row-margin">
          <label>
            Deadline Description
            <div class="resource-links-edit" [froalaEditor]="deadlineDescriptionEditorOptions" [(froalaModel)]="taxStrategy.deadlineDescription"></div>
          </label>
        </div>
        <div class="medium-6 columns row-margin">
          <label>
            Amount Type
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="amountTypes" [setPlaceHolder]="'Select Amount Type'"
                                   [setSearchKey]="'key'" [setValueKey]="'value'" [setDefaultValue]="taxStrategy.amountType"
                                   (onValueSelect)="setAmountType($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <!-- investment checkbox and logic -->
        <div class="medium-12 columns row-margin" *ngIf="isInvestmentFeature">
          <label>
            <input type="checkbox" [(ngModel)]="showInvestmentFormula">
            Strategy requires investment?
          </label>
        </div>
        
        <div class="medium-12 columns row-margin" *ngIf="showInvestmentFormula &&  isInvestmentFeature" >
          <label>
            Strategy Investment Formula
          </label>
          <div style="display:flex; align-items:center; flex-wrap:wrap; gap:12px;">
            <!-- Investment Input -->
            <input type="text" class="form-control" maxlength="200" style="width:60%;" placeholder="Enter Strategy Investment Formula"
              [(ngModel)]="taxStrategy.investmentFormula" [readonly]="isInvestmentFormulaReadonly">
        
            <!-- Tick (save) -->
            <i *ngIf="!isInvestmentFormulaReadonly" class="ion-ios-checkmark-outline"
              style="font-size:22px; cursor:pointer; color:green; margin-left:8px;" (click)="saveInvestmentFormula()">
            </i>
        
            <!-- Pencil (edit) -->
            <i *ngIf="isInvestmentFormulaReadonly" class="ion-edit"
              style="font-size:22px; cursor:pointer; color:#1570EF; margin-left:8px;" (click)="editInvestmentFormula()">
            </i>
        
        
            <!-- Cross -->
            <i class="ion-ios-close-outline" style="font-size:22px; cursor:pointer; color:red;"
              (click)="clearInvestmentFormula()"></i>
        
            <!-- OR + Calculator -->
            <div style="display:flex; align-items:center; margin-left:10px;">
              <span style="margin-right:10px; font-weight:500;">(OR)</span>
        
              <span class="badge-tooltip">
                <i class="icon ion-ios-calculator-outline" style="font-size:22px; cursor:pointer;"
                  (click)="openInvestmentFormulaCalculator()"></i>
                <span class="bottomTooltiptext tpActionTooltip" style="font-size:13px !important; width:150px !important;">
                  Build your formula</span>
              </span>
            </div>
          </div>
        </div>

        <div class="medium-12 columns row-margin" *ngIf="showInvestmentFormula && isInvestmentFeature">
          <label>
            Investment Description
            <textarea rows="3" class="form-control" placeholder="Describe the investment" [(ngModel)]="taxStrategy.investmentDescription"></textarea>
          </label>
        </div>

        <div class="medium-12 columns">
          <label *ngIf="displayTags">
            Tags
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="tagsList" [setPlaceHolder]="'Tags'" [setSearchKey]="'label'" [setValueKey]="'id'" [setDefaultValue]=""
                                   (onValueSelect)="onTagSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-12 columns">
          <div class="column small-12 medium-3" style="float: left;margin-top: 10px;" *ngFor="let value of selectedTagValues;let i = index">
          <span class="radius secondary label" style="background: #14B5F0;color: #FFFFFF" >
            <span style="color: #FFF;white-space:nowrap;overflow:hidden;text-overflow: ellipsis;width: 95px;display:inline-block" >{{value.label}}</span>
            <span class="pointer" (click)="removeSelectedTagValue(i)" style="margin-left: 5px;color: #FFF">
              <i class="icon ion-close-round"></i>
            </span>
          </span>
          </div>
        </div>
        <div class="medium-12 columns row-margin">
        <span class="pointer popup-label" style="color: #1570EF" (click)="toggleAddTag()">
            <i class="icon ion-ios-plus-outline"></i>Tag
        </span>
        </div>
        <div class="medium-12 columns" *ngIf="isNewTagAdd">
          <input type="text" class="float-left" style="width: 50%" [(ngModel)]="tagName" placeholder="Enter Tag Name"/>
          <span class="tpiq-input-search">
          <input class="add-button pointer" type="button" value="Add" (click)="addNewTagToFirmsList()"/>
        </span>
          <span>
          <i class="icon ion-ios-close-outline manage-strategy-icon" style="margin-left: 10px;" (click)="toggleAddTag()"></i>
        </span>
        </div>
        <div class="medium-12 columns row-margin" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="address-bar row-margin">
          <span class="pointer popup-label" style="color: #1570EF" (click)="appendCriteria()">
            <i class="icon ion-ios-plus-outline"></i>Criteria
          </span>
          </div>
          <div class="row address-bar row-margin" *ngFor="let criteriaLine of taxStrategy.criteria; let index = index;">
            <div class="medium-12 columns">
              <div style="flex:2">
                <input type="text" style="width: 95%; float: left;" [(ngModel)]="criteriaLine.text" placeholder="Eligibility criteria"/>
                <span class="pointer custom-rate-remove" (click)="deleteCriteria(index)"><i class="icon ion-ios-trash-outline"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns row-margin">
          <label>
            Client Overview
            <div class="resource-links-edit" [froalaEditor]="clientOverviewEditorOptions" [(froalaModel)]="taxStrategy.clientOverview"></div>
          </label>
        </div>
        <div class="medium-12 columns">
          <label>
            Client Resources
            <div class="resource-links-edit" [froalaEditor]="clientResourcesEditorOptions" [(froalaModel)]="taxStrategy.clientResources"></div>
          </label>
        </div>
        <div class="medium-12 columns">
          <label>
            Client Resource Files
            <section class="upload-area create-post" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)" (fileOver)="fileOverBase($event)">
              <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
                <div class="columns medium-12 text-center">
                  <span style="color: #475467;font-size: 14px;">Drag File Here Or </span>
                  <label for="clientResourceUpload" class="button" style="background: transparent;text-decoration: underline;padding: 0px;margin-top: 1rem;color: #1570EF !important;font-size: 14px">Browse</label>
                  <input type="file" id="clientResourceUpload" (change)="fileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
                </div>
              </div>
            </section>
          </label>
        </div>
        <div class="medium-12 columns row-margin" *ngIf="taxStrategy.clientResourceFiles.length > 0">
          <div class="row">
            <div class="small-12 medium-6 columns" *ngFor="let file of taxStrategy.clientResourceFiles; let i=index;">
              <div class="row tp-file-item-box">
                <div class="medium-8 pointer" title="{{file.name}}">
                  <div class="tp-file-item-name">{{file.name}}</div>
                </div>
                <div class="column medium-4 post-icons">
                  <i class="icon ion-ios-trash float-right post-icons-pad remove-upload" style="margin-left: 5px;" (click)="deleteDocumentFile(file, i, 'clientResource')"></i>
                  <i class="icon ion-ios-cloud-download-outline float-right post-icons-pad" (click)="getFileData(file)"></i>
                </div>
                <div class="small-12 medium-12 columns" *ngIf="file.fileType == 'image'">
                  <div class="row" style="padding: 0px;margin-left: 0px">
                    <img class="image-zoom" [src]="file.temporaryURL"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="medium-12 columns" style="margin-top: 20px;" *ngIf="currentSection == 'internal'">
      <div class="row">
        <div class="medium-12 columns">
          <label style="font-weight: 600;color: #333333;">Internal Details</label>
          <label style="font-size: 12px;font-weight: 400;color: #475467;">Provide Internal Tax Strategy's Information</label>
          <hr/>
        </div>
      </div>
      <div class="tax-strategy">
        <div foundation class="reports">
          <div class="row">
            <div class="medium-12 columns" style="padding: 0;">
              <ul class="reports tabs" data-tabs id="report-tabs" style="background: #F5F5F5;padding: 0;">
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'notes'}"><a id="a-notes"(click)="switchPage('notes')" aria-selected="true"><h6>Notes</h6></a></li>
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'opportunities'}"><a id="a-opportunities" (click)="switchPage('opportunities')" aria-selected="false"><h6>Opportunities</h6></a></li>
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'risks'}"><a id="a-risks" (click)="switchPage('risks')" aria-selected="false"><h6>Risks</h6></a></li>
              </ul>
            </div>
          </div>
          <div class="reports" data-tabs-content="report-tabs">
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'notes'" id="notes">
              <div class="row">
                <div class="medium-12 columns">
                  <label>
                    Notes
                    <div style="max-height: inherit;" class="resource-links-edit" [froalaEditor]="editorOptions" [(froalaModel)]="taxStrategy.description"></div>
                  </label>
                </div>
              </div>
            </div>
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'opportunities'" id="opportunities">
              <div class="row">
                <div class="medium-12 columns row-margin" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
                  <div class="address-bar row-margin">
                    <label style="display: inline-block">Opportunities</label>
                    <span class="pointer popup-label float-right" style="color: #1570EF" (click)="appendOpportunity()">
              <i class="icon ion-ios-plus-outline"></i>Opportunity
            </span>
                  </div>
                  <div class="row address-bar row-margin" *ngFor="let opportunity of taxStrategy.opportunities; let index = index;">
                    <div class="medium-12 columns">
                      <div style="flex:2">
                        <input type="text" style="width: 95%; float: left;" [(ngModel)]="opportunity.description" placeholder="Opportunity"/>
                        <span class="pointer custom-rate-remove" (click)="deleteOpportunity(index)"><i class="icon ion-ios-trash-outline"></i></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'risks'" id="risks">
              <div class="row">
                <div class="medium-12 columns row-margin" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
                  <div class="address-bar row-margin">
                    <label style="display: inline-block">Potential Risks</label>
                    <span class="pointer popup-label float-right" style="color: #1570EF" (click)="appendPotentialRisk()">
              <i class="icon ion-ios-plus-outline"></i>Potential Risk
            </span>
                  </div>
                  <div class="row address-bar row-margin" *ngFor="let risk of taxStrategy.potentialRisks; let index = index;">
                    <div class="medium-12 columns">
                      <div style="flex:2">
                        <input type="text" style="width: 95%; float: left;" [(ngModel)]="risk.description" placeholder="Potential Risk"/>
                        <span class="pointer custom-rate-remove" (click)="deleteRisk(index)"><i class="icon ion-ios-trash-outline"></i></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="medium-12 columns" style="margin-top: 20px;" *ngIf="currentSection == 'resources'">
      <div class="row">
        <div class="medium-12 columns">
          <label style="font-weight: 600;color: #333333;">Resources</label>
          <label style="font-size: 12px;font-weight: 400;color: #475467;">Provide Resources Information</label>
          <hr/>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns row-margin">
          <label>
            Links
            <div class="resource-links-edit" [froalaEditor]="linkEditorOptions" [(froalaModel)]="taxStrategy.resources.links"></div>
          </label>
        </div>
        <!--
                <div class="medium-12 columns">
                  <label>
                    Preferred Vendors
                    <div class="resource-links-edit" [froalaEditor]="preferredVendorsEditorOptions" [(froalaModel)]="taxStrategy.preferredVendors"></div>
                  </label>
                </div>
        -->
        <div class="medium-12 columns row-margin">
          <label>
            Files
            <section class="upload-area create-post" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)" (fileOver)="fileOverBase($event)">
              <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
                <div class="columns medium-12 text-center">
                  <span style="color: #475467;font-size: 14px;">Drag File Here Or </span>
                  <label for="resourceUpload" class="button" style="background: transparent;text-decoration: underline;padding: 0px;margin-top: 1rem;color: #1570EF !important;font-size: 14px">Browse</label>
                  <input type="file" id="resourceUpload" (change)="fileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
                </div>
              </div>
            </section>
          </label>
        </div>
        <div class="medium-12 columns row-margin" *ngIf="taxStrategy.resources.files.length > 0">
          <div class="row">
            <div class="small-12 medium-6 columns" *ngFor="let file of taxStrategy.resources.files; let i=index;">
              <div class="row tp-file-item-box">
                <div class="medium-8 pointer file-font" title="{{file.name}}">
                  <div class="tp-file-item-name">{{file.name}}</div>
                </div>
                <div class="column medium-4 post-icons">
                  <i class="icon ion-ios-trash float-right post-icons-pad remove-upload" style="margin-left: 5px;" (click)="deleteDocumentFile(file, i, 'resource')"></i>
                  <i class="icon ion-ios-cloud-download-outline float-right post-icons-pad" (click)="getFileData(file)"></i>
                </div>
                <div class="small-12 medium-12 columns" *ngIf="file.fileType == 'image'">
                  <div class="row" style="padding: 0px;margin-left: 0px">
                    <img class="image-zoom" [src]="file.temporaryURL"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns row-margin">
          <label>
            Videos
            <section class="upload-area create-post" ng2FileDrop [uploader]="videoUploader" (onFileDrop)="videoFileDropOver($event)" (fileOver)="videoFileOverBase($event)">
              <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseVideoDropZoneOver}">
                <div class="columns medium-12 text-center">
                  <span style="color: #475467;font-size: 14px;">Drag Videos Here Or </span>
                  <label for="videoUpload" class="button" style="background: transparent;text-decoration: underline;padding: 0px;margin-top: 1rem;color: #1570EF !important;font-size: 14px">Browse</label>
                  <input type="file" id="videoUpload" (change)="videoFileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="videoUploader" multiple/>
                </div>
              </div>
            </section>
          </label>
        </div>
        <div class="medium-12 columns row-margin" *ngIf="taxStrategy.resources.videos.length > 0">
          <div class="row home-page-content">
            <div class="small-12 medium-6 columns" *ngFor="let video of taxStrategy.resources.videos; let index = index;">
              <div class=" tp-file-item-box">
                <div class="tp-file-item-box row-margin-bottom">
                  <div class="pointer file-font" title="{{video.name}}">
                    <div class="tp-file-item-name">
                      {{video.name}}
                      <i class="icon ion-ios-trash float-right post-icons-pad remove-upload" (click)="deleteVideoDocumentFile(video, index)"></i>
                    </div>
                  </div>
                </div>
                <div *ngIf="video" class="text-center">
                  <video class="video-tag" style="margin: 0 auto;width: '100%'; height: 300px;" oncontextmenu="return false;" controlsList="nodownload" controls="" preload="auto" poster=""><source src="{{video.link}}" type="video/mp4"></video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="medium-12 columns" style="margin-top: 20px;" *ngIf="currentSection == 'tasks'">
      <div class="row">
        <div class="medium-12 columns">
          <label style="font-weight: 600;color: #333333;">Tasks</label>
          <label style="font-size: 12px;font-weight: 400;color: #475467;">Provide Client Tasks Information</label>
          <hr/>
        </div>
        <div class="medium-12 columns row-margin">
          <label>Setup</label>
        </div>
        <div class="medium-12 columns row-margin" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="address-bar row-margin">
            <label style="display: inline-block">Check Lists</label>
            <span class="pointer popup-label float-right" style="color: #1570EF" (click)="toggleAddChecklist('Setup')">
              <i class="icon ion-ios-plus-outline"></i>Add Checklists
            </span>
          </div>
          <div class="medium-12 columns" *ngIf="isNewSetupChecklist">
            <input type="text" class="float-left" style="width: 50%" [(ngModel)]="setupChecklistName" placeholder="Checklist Name"/>
            <span class="tpiq-input-search">
              <input class="add-button pointer" type="button" value="Add" (click)="addNewChecklist('Setup')"/>
            </span>
            <textarea rows="2" placeholder="Description..." [(ngModel)]="setupChecklistDescription"></textarea>
          </div>
          <div class="medium-12 columns">
            <div class="row workflow-status add-accordion">
              <div class="small-12 medium-12 columns selectedValues">
                <!--                <label class="head-label">-->
                <!--                  <span class="head-name head-quote" style="text-transform: none">Drag and drop to sort Checklist & Tick mark to make Checklist Mandatory</span>-->
                <!--                </label>-->
                <ul class="sortableChecklist drilldown-column status-column" style="list-style: none;">
                  <li class="status-close" [ngClass]="value.editingName ? 'input-status-edit' : 'ui-state-default' " *ngFor="let value of checklist;let i = index" style="clear: both">
                    <span style="display: none">{{value.id}}</span>
                    <span class="pointer checklist-checkbox float-left" [hidden]="value.editingName">
                    <input class="check-icon" type="checkbox" [(ngModel)]="value.mandatory" [ngModelOptions]="{standalone: true}">
                  </span>
                    <span class="fix-color" [hidden]="value.editingName">{{value.name}}</span>

                    <input type="text" style="height: 25px; width: 90%; float: left;" [(ngModel)]="value.tempName" [ngModelOptions]="{standalone: true}" [hidden]="!value.editingName"/>
                    <i class="ion-ios-checkmark-outline save-row-icon float-left" style="font-size: 21px; margin-left: 5px;" [hidden]="!value.editingName" (click)="updateChecklist($event,value)"></i>
                    <i class="icon ion-ios-close-outline manage-strategy-icon float-left" style="font-size: 21px; margin-left: 5px; color: #878787;" [hidden]="!value.editingName" (click)="stopEditingName($event, value)"></i>

                    <span class="pointer float-right">
                  <i class="icon ion-chevron-up workflow-font float-left" style="color: #FFFFFF; font-size: 16px;" [hidden]="!value.editingName && !value.showDescription" (click)="toggleDescription(value)"></i>
                  <i class="icon ion-chevron-down workflow-font float-left" style="color: #FFFFFF; font-size: 16px; margin-top: -2px;" [hidden]="!value.editingName && value.showDescription" (click)="toggleDescription(value)"></i>
                </span>
                    <span class="pointer checklist-remove float-right" [hidden]="value.editingName" (click)="removeCheckListValue(i, checklist)">
                  <i class="icon ion-close-round workflow-font"></i>
                </span>
                    <span class="pointer checklist-remove float-right" [hidden]="value.editingName" (click)="editChecklist($event, i, value, 'Setup')">
                  <i class="icon ion-edit ion-close-round workflow-font"></i>
                </span>
                    <!--                <div class="strategy-checklist-description" [froalaEditor]="checklistDescEditorOptions" [(froalaModel)]="value.description" *ngIf="value.showDescription || value.editingName"></div>-->
                    <textarea *ngIf="value.showDescription || value.editingName" rows="2" style="color: #666666;font-size: 14px;margin: 0" placeholder="Description..." [(ngModel)]="value.description" [ngModelOptions]="{standalone: true}" ></textarea>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns row-margin">
          <label>Recurring</label>
        </div>
        <div class="medium-12 columns row-margin" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="address-bar row-margin">
            <label style="display: inline-block">Check Lists</label>
            <span class="pointer popup-label float-right" style="color: #1570EF" (click)="toggleAddChecklist('Recurring')">
              <i class="icon ion-ios-plus-outline"></i>Add Checklists
            </span>
          </div>
          <div class="medium-12 columns" *ngIf="isNewRecurringChecklist">
            <input type="text" class="float-left" style="width: 50%" [(ngModel)]="recurringChecklistName" placeholder="Checklist Name"/>
            <span class="tpiq-input-search">
              <input class="add-button pointer" type="button" value="Add" (click)="addNewChecklist('Recurring')"/>
            </span>
            <textarea rows="2" placeholder="Description..." [(ngModel)]="recurringChecklistDescription"></textarea>
          </div>
          <div class="medium-12 columns">
            <div class="row workflow-status add-accordion">
              <div class="small-12 medium-12 columns selectedValues">
                <!--                <label class="head-label">-->
                <!--                  <span class="head-name head-quote" style="text-transform: none">Drag and drop to sort Checklist & Tick mark to make Checklist Mandatory</span>-->
                <!--                </label>-->
                <ul class="sortableRecurringChecklist drilldown-column status-column" style="list-style: none;">
                  <li class="status-close" [ngClass]="value.editingName ? 'input-status-edit' : 'ui-state-default' " *ngFor="let value of recurringChecklists;let i = index" style="clear: both">
                    <span style="display: none">{{value.id}}</span>
                    <span class="pointer checklist-checkbox float-left" [hidden]="value.editingName">
                    <input class="check-icon" type="checkbox" [(ngModel)]="value.mandatory" [ngModelOptions]="{standalone: true}">
                  </span>
                    <span class="fix-color" [hidden]="value.editingName">{{value.name}}</span>

                    <input type="text" style="height: 25px; width: 90%; float: left;" [(ngModel)]="value.tempName" [ngModelOptions]="{standalone: true}" [hidden]="!value.editingName"/>
                    <i class="ion-ios-checkmark-outline save-row-icon float-left" style="font-size: 21px; margin-left: 5px;" [hidden]="!value.editingName" (click)="updateChecklist($event,value)"></i>
                    <i class="icon ion-ios-close-outline manage-strategy-icon float-left" style="font-size: 21px; margin-left: 5px; color: #878787;" [hidden]="!value.editingName" (click)="stopEditingName($event, value)"></i>

                    <span class="pointer float-right">
                  <i class="icon ion-chevron-up workflow-font float-left" style="color: #FFFFFF; font-size: 16px;" [hidden]="!value.editingName && !value.showDescription" (click)="toggleDescription(value)"></i>
                  <i class="icon ion-chevron-down workflow-font float-left" style="color: #FFFFFF; font-size: 16px; margin-top: -2px;" [hidden]="!value.editingName && value.showDescription" (click)="toggleDescription(value)"></i>
                </span>
                    <span class="pointer checklist-remove float-right" [hidden]="value.editingName" (click)="removeCheckListValue(i, recurringChecklists)">
                  <i class="icon ion-close-round workflow-font"></i>
                </span>
                    <span class="pointer checklist-remove float-right" [hidden]="value.editingName" (click)="editChecklist($event, i, value, 'Recurring')">
                  <i class="icon ion-edit ion-close-round workflow-font"></i>
                </span>
                    <!--                <div class="strategy-checklist-description" [froalaEditor]="checklistDescEditorOptions" [(froalaModel)]="value.description" *ngIf="value.showDescription || value.editingName"></div>-->
                    <textarea *ngIf="value.showDescription || value.editingName" rows="2" style="color: #666666;font-size: 14px;margin: 0" placeholder="Description..." [(ngModel)]="value.description" [ngModelOptions]="{standalone: true}" ></textarea>

                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns row-margin">
          <label>Client To-Do's</label>
        </div>
        <div class="medium-12 columns row-margin" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="small-12 columns medium-12">
            <div class="address-bar row-margin">
              <span class="pointer popup-label float-right" style="color: #1570EF" (click)="appendClientTodo()">
                <i class="icon ion-ios-plus-outline"></i>Add Client To-Do's
              </span>
            </div>
          </div>
          <div class="small-12 columns medium-12">
            <div class="row" *ngFor="let todo of taxStrategy.clientTodos; let index = index;">
              <div class="medium-4 columns">
                <input type="text" [(ngModel)]="todo.name" placeholder="Todo Title"/>
              </div>
              <div class="medium-8 columns">
                <div class="resource-links-edit" style="width: 95%; float: left;" [froalaEditor]="clientTodoEditorOptions" [(froalaModel)]="todo.description"></div>
                <span class="pointer custom-rate-remove" style="margin-left: 4px;" (click)="deleteClientTodo(index)"><i class="icon ion-ios-trash-outline"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns row-margin">
          <label>Firm's Customization</label>
        </div>
        <div class="medium-12 columns">
          <label>
            Content
            <div class="resource-links-edit" [froalaEditor]="firmCustomizationEditorOptions" [(froalaModel)]="taxStrategy.firmCustomizations.content"></div>
          </label>
        </div>
        <div class="medium-12 columns">
          <label>
            Files
            <section class="upload-area create-post" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)" (fileOver)="fileOverBase($event)">
              <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
                <div class="columns medium-12 text-center">
                  <span style="color: #475467;font-size: 14px;">Drag File Here Or </span>
                  <label for="firmCustomizationUpload" class="button" style="background: transparent;text-decoration: underline;padding: 0px;margin-top: 1rem;color: #1570EF !important;font-size: 14px">Browse</label>
                  <input type="file" id="firmCustomizationUpload" (change)="fileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
                </div>
              </div>
            </section>
          </label>
        </div>
        <div class="medium-12 columns row-margin" *ngIf="taxStrategy.firmCustomizations.files.length > 0">
          <div class="row">
            <div class="small-12 medium-6 columns" *ngFor="let file of taxStrategy.firmCustomizations.files; let i=index;">
              <div class="row tp-file-item-box" >
                <div class="medium-8 pointer file-font" title="{{file.name}}">
                  <div class="tp-file-item-name">{{file.name}}</div>
                </div>
                <div class="column medium-4 post-icons">
                  <i class="icon ion-ios-trash float-right post-icons-pad remove-upload" style="margin-left: 5px;" (click)="deleteDocumentFile(file, i, 'firmCustomizations')"></i>
                  <i class="icon ion-ios-cloud-download-outline float-right post-icons-pad" (click)="getFileData(file)"></i>
                </div>
                <div class="small-12 medium-12 columns" *ngIf="file.fileType == 'image'">
                  <div class="row" style="padding: 0px;margin-left: 0px">
                    <img class="image-zoom" [src]="file.temporaryURL"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="medium-12 columns" style="margin-top: 20px; "*ngIf="currentSection == 'review'">
      <div class="row">
        <div class="medium-12 columns">
          <label style="font-weight: 600;color: #333333;">Review</label>
          <label style="font-size: 12px;font-weight: 400;color: #475467;">Check your given information before creating the strategy</label>
          <hr/>
        </div>
      </div>
      <mat-accordion multi>
        <mat-expansion-panel class="tp-accordion" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Overview
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-tax-strategy-overview [taxStrategy]="taxStrategy" [showInfoTooltips]="false"></app-tax-strategy-overview>
        </mat-expansion-panel>
        <mat-expansion-panel class="tp-accordion">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Internal
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-tax-strategy-internal [taxStrategy]="taxStrategy"></app-tax-strategy-internal>
        </mat-expansion-panel>
        <mat-expansion-panel class="tp-accordion">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Resources
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-tax-strategy-resources [taxStrategy]="taxStrategy"></app-tax-strategy-resources>
        </mat-expansion-panel>
        <mat-expansion-panel class="tp-accordion">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Tasks
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-tax-strategy-tasks [taxStrategy]="taxStrategy" [checklist]="checklist" [recurringChecklists]="recurringChecklists"></app-tax-strategy-tasks>
        </mat-expansion-panel>
      </mat-accordion>

    </div>
  </div>
  <div class="row" style="margin-top: 20px;">
    <div class="medium-12">
      <button class="button small float-right" *ngIf="currentSection == 'review'" (click)="saveStrategy()">{{(editMode) ? 'Update' : 'Create'}}</button>
      <button class="button small float-right" *ngIf="currentSection != 'review'" (click)="goToNextSection()">Next</button>
      <button class="button small float-right" *ngIf="currentSection != 'overview'" style="border: 1px solid #D0D5DD;border-radius: 6px;background: #FFFFFF;color:#333333;" (click)="goToPreviousSection()">Previous</button>
      <button class="button small float-right cancel-button" (click)="closeCreatePopup()">Cancel</button>
    </div>
  </div>
</div>

<div *ngIf="reveal['fromulaCalculator']">
  <app-formula-builder (buildAssociatedObject)="buildAssociatedObject()" (onHideReveal)="hideReveal('fromulaCalculator')"
                       (onProgpageCustomRate)="propageCustomRateChange($event)" (onUpdateTaxRatesInFormula)="updateTaxRatesInFormula()"
                       (refreshTableData)="refreshTableData()" (triggerCloseAddCustomRateInStrategyPage)="addOrUpdateCustomRate($event)"
                       (triggerCloseEditCustomRate)="triggerCloseEditCustomRate($event)"
                       (triggerRecalcAndUpdatePlan)="triggerRecalcAndUpdatePlan($event)"
                       [actionType]="'create'"
                       [addingCustomRatesArray]="tempCustomRates"
                       [allAssociatedData]="allAssociatedData"
                       [associatedWith]="associatedWith"
                       [clientTaxPlan]="taxStrategy"
                       [customRate]="tempCustomRateObject"
                       [fixedRatesArray]="fixedRatesArray"
                       [indexOfTempCustomObj]="indexOfTempCustomRateObject"
                       [isCustomRateEdit]="isCustomRateEdit"></app-formula-builder>
</div>
<!--New Investment Calculator app builder code-->
<app-investment-formula-builder *ngIf="showInvestmentCalculatorPopup" [actionType]="'emit'"
  [investmentfixedRatesArray]="investmentfixedRatesArray" [existingInvestmentValue]="taxStrategy.investmentFormula" (onCustomRateAction)="handleInvestmentFormula($event)"
  (onHideReveal)="closeInvestmentFormulaCalculator()">
</app-investment-formula-builder>

<div *ngIf="reveal['suggesttion']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['suggesttion']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'tpiq-reveal': reveal['suggesttion']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Confirmation</span>
      <span class="float-right pointer" (click)="hideReveal('suggesttion')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>

    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <span>Would you like to suggest your changes to AdvisorIQ?</span>
        </div>
      </div>
      <div class="row-padding-reveal text-right">
        <button class="button small" (click)="acceptOrDenySuggestedChanges('accept')">YES</button>
        <button class="button small" style="background: #f1645a !important;" (click)="acceptOrDenySuggestedChanges('deny')">NO</button>
      </div>
    </div>
  </div>
</div>

